<template>
  <div class="supplier-search">

    <v-form ref="formSearch" lazy-validation v-on:submit.prevent="onSubmit">
      <v-container>
        <v-row>
          <v-col>
            <v-text-field label="検索ワード"
                          v-model="condition.query_words"
                          placeholder="検索したい工程、特徴、条件などを空白で区切って入力して下さい。"
                          @keydown.enter="onSearchEnter"></v-text-field>
          </v-col>
        </v-row>


        <v-row>
          <v-col class="py-0" cols="12">
            <span class="subtitle-2">対応サイズ</span>
          </v-col>
        </v-row>
          <v-row>

            <template v-for="sizeItem in condition.sizes">

              <v-col v-if="sizeItem.useRange" :key="sizeItem.sizeCd" class="py-0" cols="4" sm="8" md="4">
                <div class="d-flex align-center pa-0 ma-0">
                  <v-text-field
                      :label="sizeItem.sizeName"
                      v-model.number="sizeItem.value1"
                      :suffix="sizeItem.unit"
                  ></v-text-field>
                  <div class="px-2"><span>〜</span></div>
                  <v-text-field
                      v-model.number="sizeItem.value2"
                      :suffix="sizeItem.unit"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col v-else :key="sizeItem.sizeCd" class="py-0" cols="2" sm="4" md="2">
                <v-text-field
                    :label="sizeItem.sizeName"
                    v-model.number="sizeItem.value1"
                    :suffix="sizeItem.unit"
                ></v-text-field>
              </v-col>

            </template>

          </v-row>



        <v-row>
          <v-col class="pb-0" cols="12">
            <span class="subtitle-2">対応素材</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <div class="d-flex pa-0 ma-0">
              <v-checkbox v-for="mat in materials" :key="mat.materialCd" class="my-0 mr-5" :label="mat.materialName" :value="mat.materialCd" v-model="condition.materials"></v-checkbox>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pb-0" cols="12">
            <span class="subtitle-2">対応母材形状</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <div class="d-flex pa-0 ma-0">
              <v-checkbox v-for="mat in materialFaces" :key="mat.faceCd" class="my-0 mr-5" :label="mat.faceName" :value="mat.faceCd" v-model="condition.materialFaces"></v-checkbox>
            </div>
          </v-col>
        </v-row>


        <v-row>
          <v-col class="pb-0" cols="12">
            <span class="subtitle-2">評価</span>
          </v-col>
        </v-row>
          <v-row>
              <v-col v-for="score in condition.evaluates" :key="score.evaluateItemCd" cols="3" class="py-2">
                <span class="text-caption">{{ getEvaluateItemName(score.evaluateItemCd) }}</span>
                  <v-slider v-model="score.point" min="0" max="5" step="1"
                            tick-size="3" :thumb-label="score.point > 0 ? 'always' : false"
                            :messages="score.point > 0 ? (getEvaluateItemName(score.evaluateItemCd) + 'が' + score.point + '以上') : ''"></v-slider>
              </v-col>
          </v-row>

        <v-row>
          <v-col>
            <v-btn v-on:click="onSearchClick">検索</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <div>

      <v-container>

        <progress-view :loading="isLoading"></progress-view>

        <v-pagination v-model="pager.pageNo" :length="pager.pageCount" :total-visible="7" v-show="!isLoading && (pager.totalCount > 0)"></v-pagination>

        <span id="list_top_anchor"></span>

        <v-row v-for="sup in list" :key="sup.id">
          <v-col>
            <v-card>
              <v-card-title>
                <router-link :to="{ name: 'supplier', params: { sup_cd: sup.id }}"> {{ sup.name }} <!--{{ sup.id }}-->
                </router-link>
              </v-card-title>

              <v-card-text>

                <v-container class="py-0">
                  <v-row>
                    <v-col class="py-0">

                      <v-container>
                        <v-row>
                          <v-col class="py-0">
                            <span> {{ sup.address }}</span>
                            <br>
                            <span> TEL : {{ sup.tel }}</span>
                          </v-col>
                        </v-row>


                        <v-row>
                          <v-col class="py-0">
                                            <span>
                                              システム登録 : <span v-if="sup.systemCd">{{ sup.systemCd }}</span><span v-else>未登録</span>
                                            </span>
                            <br>
                            <span>登録日 : {{ formatDateToDisplay(sup.createAt) }}</span>
                            <br>
                            <span>最終発注日 : わかりません </span>
                          </v-col>
                        </v-row>

                      </v-container>

                    </v-col>

                    <v-col cols="4" class="py-0">
                      <table>
                        <tr v-for="mp in sup.scores" :key="mp.evaluateItemCd">
                          <td>{{mp.evaluateItemName}}</td>
                          <td>
                            <v-rating
                                v-model="mp.score"
                                background-color="grey lighten-1"
                                color="yellow accent-4"
                                dense
                                small
                                half-increments
                                readonly
                            ></v-rating>
                          </td>
                        </tr>
                      </table>

                    </v-col>
                    <v-col cols="3" class="py-0">
                      <image-view v-if="sup.mainPhotoId" :height="200" :width="200"
                                  :image-id="sup.mainPhotoId"></image-view>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-for="processGroup in sup.processGroups" :key="processGroup.processGroupCd" cols="3" class="py-1">

                      <v-card elevation="0" outlined>
                        <v-card-subtitle class="pt-2 pb-0">

                          <v-list-item class="pa-0" dense>
                            <v-list-item-content class="pa-0">
                              <v-list-item-title>{{ processGroup.processGroupName }}</v-list-item-title>
                              <v-list-item-subtitle>
                                <span v-for="process in processGroup.processes" :key="process.processCd">
                                  {{ process.processName }}
                                </span>                                
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                        </v-card-subtitle>
                        <v-card-text class="py-0">
                          <v-chip-group column>
                            <v-chip v-for="mat in processGroup.materials" :key="mat.materialName" outlined small color="indigo">
                              {{ mat.materialName }}
                            </v-chip>
                            <v-chip v-for="mats in processGroup.materialFaces" :key="mats.materialFaceName" outlined small
                                    color="orange">
                              {{ mats.materialFaceName }}
                            </v-chip>
                            <v-chip v-for="chip in processGroup.tags" :key="chip" outlined small color="grey">
                              {{ chip }}
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                      </v-card>


                    </v-col>
                  </v-row>
                </v-container>

              </v-card-text>

            </v-card>
          </v-col>
        </v-row>

        <v-pagination v-model="pager.pageNo" :length="pager.pageCount" :total-visible="7" v-show="!isLoading && (pager.totalCount > 0)"></v-pagination>

      </v-container>


    </div>

  </div>
</template>
<script>
import ObjectParamSupport from "../../components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
import SupplierAPI from "@/apis/SupplierAPI";
import EvaluateAPI from "@/apis/EvaluateAPI";


export default {
  mixins: [BaseView, ObjectParamSupport],
  components: {},
  props: {
    search_query: String,
    page:String
  },
  data: () => ({
    isInitialized: false,
    isFetched: false,
    isLoading: false,
    isDownloading: false,

    scoreStepCount: 10,

    // 検索条件(画面)
    condition: {
      query_words: "",
      materials: [],
      materialFaces: [],
      evaluates: [
        { evaluateItemCd:"", point:null }
      ],
      scores: [
        {label: "品質", point: 0, name: "品質評価"}
      ],
      sizes: [
        {          
          sizeCd: "width", sizeName: "幅", unit: "mm",value1:null
        }
      ],
    },

    materialStyle: [
      {name: "立方体"},
    ],

    list: [
      {
        id: 12334,
        name: "岡本表面加工研究所株式会社 ",
        area: "加賀市",
        tel: "0761-123-4567",
        fax: "0761-123-4569",
        address: "石川県加賀市広小路１２３−４５６",
        representative: "加賀野 太郎",
        url: "https://aaaa.bbbb.co.jp",
        web_conference: [1, 2, 3],

        suppliers: [
          {name: "ああ工業所"},
          {name: "いい鉄鋼所"},
        ],
        customers: [
          {name: "大日本ロケット"},
        ],

        process: [
          {
            name: "機械加工",
            no: 1,
            tags: [
              {name: "ねじ切り"}
            ],
          },
          {
            name: "溶接",
            no: 2,
            tags: [
              {name: "レーザー"}
            ],
          }
        ],

        score:[
          {
            evaluateItemCd:"",
            score:1,
            evaluateCount:1,
            evaluateItemName:""
          }
        ],

      },
    ],


    pager: {
      pageNo:0,
      totalCount:0,
      pageCount:0,
      pageSize:0
    },
    errors: {},
  }),

  computed: {
    scoreTickLabels: function () {
      return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
    },

    // Vuex.Storeのデータ参照
    materials: function () {
      return this.$store.state.materials;
    },
    materialMap: function () {
      return this.$store.state.materialMap;
    },
    materialFaces: function () {
      return this.$store.state.materialFaces;
    },
    materialFaceMap: function () {
      return this.$store.state.materialFaceMap;
    },

    processMap: function () {
      return this.$store.state.processings.processMap;
    },


    process_groups: function () {
      return this.$store.state.processings.groups;
    },

    processGroupMap: function () {
      return this.$store.state.processings.groupMap;
    },


  },
  mounted: function () {
    this.list.splice(0);
    this.setupConditions();
  },
  created: function () {
  },
  watch: {
    '$route': function (to, from) {
      this.setupConditions();
    },

    'pager.pageNo':function (to){
      if (!!to && (this.pager.pageNo != to)){
        this.onPageChange(to);
      }
    },

  },
  methods: {

    setupConditions() {

      // 初期設定
      // 評価項目の条件を設定
      let evItems = this.getEvaluateItemList();      
      this.condition.evaluates.splice(0)
      evItems.forEach(cd =>{
        this.condition.evaluates.push({
          evaluateItemCd : cd,
          point: null
        })
      })

      // 対応サイズの条件を設定
      this.condition.sizes.splice(0)
      this.sizeItems.forEach(si => {
        this.condition.sizes.push({
          sizeCd: si.sizeCd, 
          sizeName: si.sizeName, 
          unit: si.unit,
          value1:null
        })
      })



      if (this.page){
        this.pager.pageNo = Number(this.page);
      }


      let needFetch = false;
      if (this.search_query) {
        // 他の画面から検索された場合
        this.condition.query_words = this.search_query;
        this.onSearchClick()
      } else {

        // パラメータの転写
        let p = this.getObjectParam();
        if (p) {

          this.logger.info("objectParam", p)
          let sq = p.qw;
          if (sq) {
            this.condition.query_words = sq
            needFetch = true;
          }
          let mt = p.mt;
          if (mt) {
            this.condition.materials.splice(0)
            mt.forEach(v => this.condition.materials.push(v))
            needFetch = true;
          }
          let mtf = p.mtf;
          if (mtf) {
            this.condition.materialFaces.splice(0)
            mtf.forEach(v => this.condition.materialFaces.push(v))
            needFetch = true;
          }

          let evl = p.evl;
          if (evl){
            this.condition.evaluates.splice(0)
            evl.forEach(v => {
              let c = {
                evaluateItemCd : v.cd,
                point: v.p
              }
              this.condition.evaluates.push(c)
            })
          }

          if (p.sizes){
            this.condition.sizes.splice(0)            
            p.sizes.forEach(si => {
              let sim = this.sizeItemMap[si.sizeCd];
              let v1 = (si.value1) ? Number(si.value1) : null;
              //let v2 = (si.value2) ? Number(si.value2) : null;

              this.condition.sizes.push({
                sizeCd: si.sizeCd, 
                sizeName: sim.sizeName, 
                unit: sim.unit,
                value1:v1,
              })
            });

          }


        }
      }

      this.fetchData(needFetch)
    },

    fetchData(needDataFetch) {

      let self = this;

      if (!this.isInitialized) {
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }

      if (needDataFetch) {
        this.isLoading = true;


        let sizes = null;
        if (this.condition.sizes.length > 0){
          sizes = this.condition.sizes.map(si => {
            let elm = {
              sizeCd:si.sizeCd,
              value1:si.value1,
            };           
            return elm
          })
        }

        let queryCondition = {
          text: this.condition.query_words,
          materials:this.condition.materials,
          materialFaces:this.condition.materialFaces,
          evaluates:this.condition.evaluates,
          sizes:sizes
        };

        this.isLoading = true;
        this.list.splice(0);

        console.log("SupplierAPI.search queryCondition",queryCondition);

        Promise.resolve()
            .then(a => SupplierAPI.search(queryCondition,this.page))
            .then(data => this.makeDisplayData(data))
            .catch(function (err) {
              console.log(err);
              self.showErrorToast("データの取得に失敗しました。");
            })
            .finally(function() {
              self.isLoading = false;
            });
      }

    },

    fetchBasicData(finishProc) {
      this.isInitialized = true;
      if (finishProc) {
        finishProc();
      }
    },

    onSubmit(){
      this.onSearchClick();
    },
    onSearchEnter(event) {
      //console.log("onConditionEnter keyCode=" + event.keyCode)
      // 通常のEnterはkeyCode = 13
      // 日本語入力中のEnterはkeyCode = 229を返す
      if (event.keyCode === 13) {
        this.onSearchClick();
      }
    },
    onSearchClick() {

      if (!this.condition.query_words){
        this.showMessageToast("条件を入力してください。")
        return;
      }

      let p = this.buildOptionParam(this.condition)

      this.logger.info("searchCondition", p)

      let urlParam = this.makeObjectParam(p);

      let baseUrl = this.$router.currentRoute.path;

      let pageUrl = baseUrl + "?op=" + urlParam + "&p=1";

      this.$router.replace(pageUrl);
    },

    onPageChange(page){

      console.log("onPageChange page=" + page);

      let p = this.getObjectParam();

      let urlParam = this.makeObjectParam(p);

      let baseUrl = this.$router.currentRoute.path;

      let pageUrl = baseUrl + "?op=" + urlParam + "&p=" + page;

      this.$router.push(pageUrl);

    },

    // 検索条件を示すurlパラメータを生成する
    // condition は this.conditionと同じ構成とする
    buildOptionParam(condition){

      let evaluates = null;
      if (condition.evaluates.length > 0){
        evaluates = condition.evaluates.map(ev => {
          return {
            cd:ev.evaluateItemCd,
            p:ev.point
          }
        })
      }

      let sizes = null;
      if (condition.sizes.length > 0){
        sizes = condition.sizes.map(si => {
          let elm = {
            sizeCd:si.sizeCd,
            value1:si.value1,
          };
          return elm
        })
      }


      // urlに保存するパラメータを作成
      let p = {
        qw: condition.query_words,
        mt: condition.materials,
        mtf: condition.materialFaces,
        evl: evaluates,
        sizes:sizes,
      }

      return p;
    },

    makeDisplayData(data) {

      this.logger.log("makeDisplayData", data)

      this.list.splice(0);

      let records = data.records;

      // ページャーの設定
      this.pager.pageNo = data.pageIndex;
      this.pager.pageCount = data.totalPages;
      this.pager.totalCount = data.totalRecordCount;
      this.pager.pageSize = data.pageSize;


      records.forEach(rec => {
        
        let apps = rec.applications;
        let representatives = rec.representatives;
        let mainClients = rec.clients;
        let subSuppliers = rec.subSuppliers;
        let contractors = rec.contractors;
        let processGroups = rec.processGroups;
        let images = rec.images;

        let supplier = {
          id: rec.id,
          name: rec.name,
          address: rec.address1,
          tel: rec.tel,
          fax: rec.fax,
          areaCd: rec.areaCd,
          areaName: rec.areaName,
          capital: rec.capital,
          employeeNum: rec.employeeNum,
          president: rec.president,
          priority: rec.priority,
          systemCd: rec.systemCd,
          url: rec.url,
          mainPhotoId: rec.mainPhotoId,
          scores:[],
          createAt:rec.createAt,
          processGroups: this.makeProcessRecord(processGroups),
        };

        this.list.push(supplier)

        this.fetchEvaluate(supplier)
            .then(scores => {
              supplier.scores = scores;
            })

      });

      if (!records || records.length === 0){
        this.showMessageToast("条件に一致するパートナー企業が見つかりませんでした。")      
      }
      else {
        this.onScrollToListTop();
      }

    },


    makeProcessRecord(processGroups) {

      let procList = processGroups.map(pg => {

        let availableSizes = pg.availableSizes;

        let availableSizeMap = {};
        availableSizes.forEach(e => {
          availableSizeMap[e.size_item_cd] = e
        })


        let tags = pg.tags;

        let mat = pg.materials.map(psm => {
          return {            
            materialCd: psm.materialCd,
            materialName: psm.materialName
          }
        })

        let faces = pg.materialFaces.map(fcs => {
          return {            
            materialFaceCd: fcs.materialFaceCd,
            materialFaceName: fcs.materialFaceName
          }
        })

        let sizeSet = [];
        if (availableSizes) {
          sizeSet = availableSizes.map(asi => {
            let sizeRec = {
              itemCd: asi.sizeItemCd,
              name: asi.sizeItemName,
              unit: asi.unit,
              useRange: asi.useRange,
              value1: asi.size1,
              value2: asi.size2,
            };
            return sizeRec;
          });
        }


        // 工程のリスト
        let processes = pg.processes.map(proc => {          
          return {
            processCd:proc.processCd,            
            processName:proc.processName,   
          };
        });

        return {  
          processGroupCd: pg.processGroupCd,
          processGroupName: pg.processGroupName,
          availableSizes:sizeSet,
          materials:mat,          
          tags:tags,
          materialFaces:faces,
          processes:processes,
        };
      });

      return procList;
    },


    fetchEvaluate(rec){
      let self = this;
      let supplireId = rec.id;

      return Promise.resolve()
          .then(a => EvaluateAPI.getEvaluate(supplireId))
          .then(res => self.makeScoreData(res))
    },

    makeScoreData(data){

      console.log("setupScoreData",data)

      return data.map(a => {
          return {
            evaluateItemCd: a.evaluateItemCd,
            score: a.score,
            evaluateCount: a.evaluateCount,
            evaluateItemName: this.getEvaluateItemName(a.evaluateItemCd)
          }
      });

    },


    onScrollToListTop(){

      this.$vuetify.goTo("#list_top_anchor", {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });

    },


  },

}
</script>